export const DATE_TYPE = {
    PAYMENT_SOURCE: 'payment_source',
    REF_ID: 'ref_id',
};
export class Event {
    static insertToInput(selector, dataType, eventData) {
        if (typeof eventData[dataType] === "undefined")
            return;
        let input = document.querySelector(selector);
        if (!input)
            return;
        input.value = eventData[dataType];
    }
    static subscribe(name, subject, listener) {
        if (subject.addEventListener) {
            subject.addEventListener(name, listener);
        }
        else {
            subject.attachEvent(`on${name}`, listener);
        }
    }
}
//# sourceMappingURL=../../src/lib/helper/event.js.map